export default {
  getBlocks(state, blocks) {
    state.blocks = blocks;
  },
  getFieldTypes(state, fields) {
    state.fields = fields;
  },
  getType(state, type) {
    Object.assign(state.types, type);
  },
  saveEditorState(state, data) {
    state.module[data.module].data = data.data;
    state.module[data.module].content = data.content;
  },
  removeEditorState(state, module) {
    state.module[module] = {};
  },
};
